import { useContext, useState } from "react";
import { UserDataContext } from "../components/UserDataContext";
import { Formik, Form as FormikForm } from "formik";
import Dropzone from "react-dropzone";
import axios from "axios";
import { apiRequest } from "../components/Config";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Button,
  Typography,
  Card,
  CardContent,
  Box,
  Avatar,
  Stack,
  CircularProgress,
  TextField,
} from "@mui/material";
import { Row } from "react-bootstrap";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { API_URL } from "../App";
import Alerts from "../components/Alerts";

export default function Aboutme() {
  const { userData, setUserData } = useContext(UserDataContext);
  const navigate = useNavigate();
  const [preview, setPreview] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [showEmailVerifyInput, setShowEmailVerifyInput] = useState(false);
  const [emailCode, setEmailCode] = useState("");
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [apiResponse, setApiResponse] = useState({});
  const photoUrl = userData?.userId
    ? `${API_URL}/get-user-photo/${userData.userId}`
    : null;
  const initialValues = {
    file: null,
  };

  function formatPhone(phone) {
    if (!phone) return "";

    const digits = phone.replace(/\D/g, "");

    if (digits.length === 11 && digits.startsWith("48")) {
      return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{3})/, "$1 $2 $3 $4");
    }

    if (digits.length === 9) {
      return digits.replace(/(\d{3})(\d{3})(\d{3})/, "48 $1 $2 $3");
    }

    return phone;
  }

  const handleUpload = async (values, formikHelpers) => {
    const formData = new FormData();
    formData.append("file", values.file);

    try {
      const response = await axios.post(`${API_URL}/upload-photo`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
      });
    } catch (error) {
      console.error("Upload error: ", error);
      alert("Wystąpił błąd podczas przesyłania zdjęcia.");
    } finally {
      formikHelpers.setSubmitting(false);
    }
  };

  if (!userData) return null;

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      {showApiResponse && (
        <Row className="sticky-alerts-container">
          <Alerts data={apiResponse} />
        </Row>
      )}
      <Card
        sx={{
          borderRadius: 4,
          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
        }}
      >
        <CardContent sx={{ p: 5 }}>
          <Stack spacing={2} alignItems="center" mb={4}>
            <Box position="relative">
              <Avatar
                src={preview || photoUrl}
                sx={{
                  width: 110,
                  height: 110,
                  fontSize: 40,
                  boxShadow: "0 5px 15px rgba(0,0,0,0.15)",
                }}
              >
                {userData.fullName?.[0]}
              </Avatar>

              <Box
                sx={{
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  backgroundColor: "white",
                  borderRadius: "50%",
                  padding: "6px",
                  boxShadow: 2,
                }}
              >
                <PhotoCameraIcon fontSize="small" />
              </Box>
            </Box>

            <Typography variant="h5" fontWeight={600}>
              {userData.fullName}
            </Typography>
            <Typography color="text.secondary">
              <b>{userData.cityName}</b>
            </Typography>
            <Typography color="text.secondary">
              {formatPhone(userData.phone)}
            </Typography>
            <Box display="flex" flexDirection="column" gap={1}>
              <Box display="flex" alignItems="center" gap={2}>
                <Typography color="text.secondary">
                  <b>{userData.email}</b>
                </Typography>

                {userData.email_veryf === 1 ? (
                  <Typography color="success.main" variant="body2">
                    ✔ email zweryfikowany
                  </Typography>
                ) : (
                  <>
                    <Typography color="warning.main" variant="body2">
                      email nie zweryfikowany
                    </Typography>

                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => {
                        setShowEmailVerifyInput(true);
                        //console.log("ID: ", userData.userId);
                        // tutaj docelowo:
                        apiRequest("send-email-code", "POST", {
                          email: userData.email,
                        });
                      }}
                    >
                      Zweryfikuj
                    </Button>
                  </>
                )}
              </Box>

              {/* 👇 POLE NA KOD */}
              {showEmailVerifyInput && userData.email_veryf !== 1 && (
                <Box display="flex" gap={1} alignItems="center">
                  <TextField
                    label="Wpisz kod z emaila"
                    value={emailCode}
                    onChange={(e) => setEmailCode(e.target.value)}
                    error
                    helperText="Wpisz kod wysłany na Twój adres email"
                    size="small"
                    fullWidth
                  />

                  <Button
                    variant="contained"
                    size="small"
                    onClick={async () => {
                      try {
                        console.log("kod:", emailCode);

                        const response = await apiRequest(
                          "verify-email-code",
                          "POST",
                          {
                            email: userData.email,
                            code: emailCode,
                          },
                        );

                        console.log("api response:", response);

                        if (response.redirect) {
                          navigate("/login");
                        }
                        if (response.success) {
                          setApiResponse({
                            title: "Weryfikacja Email",
                            severity: "success",
                            info: "Email zweryfikowany pozytywnie.",
                          });
                          setUserData((prev) => ({
                            ...prev,
                            email_veryf: 1,
                          }));

                          setShowEmailVerifyInput(false);

                          setTimeout(() => {
                            setShowApiResponse(false);
                          }, 5000);
                        } else {
                          setApiResponse({
                            title: "Weryfikacja Email",
                            severity: "warning",
                            info: "Nieprawidłowy kod lub jego brak.",
                          });
                          setShowApiResponse(true);
                        }
                      } catch (err) {
                        console.error("Błąd:", err);
                      }
                    }}
                  >
                    OK
                  </Button>
                </Box>
              )}
            </Box>
          </Stack>

          <Formik initialValues={initialValues} onSubmit={handleUpload}>
            {({
              values,
              setFieldValue,
              setFieldTouched,
              isSubmitting,
              errors,
              touched,
            }) => (
              <FormikForm>
                <Dropzone
                  multiple={false}
                  accept={{ "image/jpeg": [".jpg", ".jpeg"] }}
                  maxSize={5 * 1024 * 1024}
                  disabled={isSubmitting}
                  onDragEnter={() => setDragActive(true)}
                  onDragLeave={() => setDragActive(false)}
                  onDrop={(acceptedFiles, rejectedFiles) => {
                    setDragActive(false);
                    if (rejectedFiles.length > 0) {
                      alert("Plik musi być JPG i mieć max 5MB");
                      return;
                    }
                    const file = acceptedFiles[0];
                    setFieldValue("file", file);
                    setFieldTouched("file", true);
                    const previewUrl = URL.createObjectURL(file);
                    setPreview(previewUrl);
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <Box
                      {...getRootProps()}
                      sx={{
                        border: "2px dashed",
                        borderColor: dragActive ? "primary.main" : "divider",
                        borderRadius: 3,
                        p: 4,
                        textAlign: "center",
                        cursor: isSubmitting ? "not-allowed" : "pointer",
                        transition: "0.25s",
                        opacity: isSubmitting ? 0.6 : 1,
                        backgroundColor: dragActive
                          ? "action.hover"
                          : "transparent",
                        "&:hover": {
                          backgroundColor: isSubmitting
                            ? "transparent"
                            : "action.hover",
                        },
                      }}
                    >
                      <input {...getInputProps()} />
                      {!preview && (
                        <>
                          <CloudUploadIcon
                            sx={{
                              fontSize: 40,
                              color: "primary.main",
                              mb: 1,
                            }}
                          />
                          <Typography fontWeight={500}>
                            Przeciągnij zdjęcie lub kliknij
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            JPG • maksymalnie 5MB
                          </Typography>
                        </>
                      )}
                      {preview && (
                        <Box>
                          <Typography fontWeight={500}>
                            Nowe zdjęcie wybrane
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {values.file?.name}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  )}
                </Dropzone>

                <Stack direction="row" spacing={2} mt={4}>
                  {preview && (
                    <Button
                      variant="outlined"
                      color="error"
                      disabled={isSubmitting}
                      startIcon={<DeleteOutlineIcon />}
                      onClick={() => {
                        setPreview(null);
                        setFieldValue("file", null);
                      }}
                    >
                      Usuń
                    </Button>
                  )}
                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    startIcon={!isSubmitting && <CloudUploadIcon />}
                    disabled={!values.file || isSubmitting}
                  >
                    {isSubmitting ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Zapisz zdjęcie"
                    )}
                  </Button>
                </Stack>

                {errors.file && touched.file && (
                  <Typography color="error" mt={2} textAlign="center">
                    {errors.file}
                  </Typography>
                )}
              </FormikForm>
            )}
          </Formik>
        </CardContent>
      </Card>
    </Container>
  );
}
